import { render, staticRenderFns } from "./SelectItemArr.vue?vue&type=template&id=116346d2&scoped=true"
import script from "./SelectItemArr.vue?vue&type=script&lang=js"
export * from "./SelectItemArr.vue?vue&type=script&lang=js"
import style0 from "./SelectItemArr.vue?vue&type=style&index=0&id=116346d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116346d2",
  null
  
)

export default component.exports